export default __webpack_public_path__ + "static/arrow_01_dark-7d9829f2fd286771b69ad3376b7b3050.png";